import React, { useState, useEffect } from 'react';

function FloatingButtons() {
  const telefonNo = "03125810881";
  const [isVisible, setIsVisible] = useState(false);

  // Sayfa kaydırma miktarını izleyen mekanizma
  useEffect(() => {
    const toggleVisibility = () => {
      // 300px'den fazla aşağı inilirse butonu göster
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  // En üste "smooth" (yağ gibi) kaydırma fonksiyonu
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="floating-container">
      
      {/* YUKARI ÇIK BUTONU - Sadece isVisible true ise görünür */}
      <button 
        className={`float-btn scroll-top-btn ${isVisible ? 'show' : ''}`} 
        onClick={scrollToTop}
        title="Yukarı Çık"
      >
        ▲
      </button>

      {/* Telefon Araması */}
      <a href={`tel:${telefonNo}`} className="float-btn phone-btn" title="Hemen Ara">
        📞
      </a>
      
      {/* WhatsApp */}
      <a href={`https://wa.me/903125810881?text=Merhaba,%20teknik%20servis%20hizmeti%20almak%20istiyorum.`} 
         target="_blank" 
         rel="noopener noreferrer" 
         className="float-btn wp-btn" 
         title="WhatsApp'tan Yaz">
        💬
      </a>
    </div>
  );
}

export default FloatingButtons;